import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

interface UseReportSnapshotParams {
  userId: string;
  periodType: PeriodType;
  periodStart: string; // YYYY-MM-DD
  periodEnd: string;   // YYYY-MM-DD
}

export function useReportSnapshot({
  userId,
  periodType,
  periodStart,
  periodEnd,
}: UseReportSnapshotParams) {
  return useQuery({
    queryKey: ['report_snapshots', userId, periodType, periodStart, periodEnd],
    queryFn: async (): Promise<ReportSnapshot | null> => {
      const { data, error } = await (supabase as any)
        .from('report_snapshots')
        .select('*')
        .eq('user_id', userId)
        .eq('period_type', periodType)
        .eq('period_start', periodStart)
        .eq('period_end', periodEnd)
        .maybeSingle();

      if (error) throw error;
      if (!data) return null;

      return {
        id: data.id,
        userId: data.user_id,
        periodType: data.period_type,
        periodStart: data.period_start,
        periodEnd: data.period_end,
        totalIncome: data.total_income,
        totalExpenses: data.total_expenses,
        netSavings: data.net_savings,
        categoryBreakdown: data.category_breakdown ?? [],
        calculatedAt: data.calculated_at,
      } as ReportSnapshot;
    },
    enabled: !!userId && !!periodStart && !!periodEnd,
  });
}
